function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m480 72c0 39.765625-32.234375 72-72 72s-72-32.234375-72-72 32.234375-72 72-72 72 32.234375 72 72zm0 0",
  fill: "#bf4653"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m272 176h176c17.671875 0 32 14.328125 32 32s-14.328125 32-32 32h-416c-17.671875 0-32-14.328125-32-32s14.328125-32 32-32h176",
  fill: "#bc8f6f"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m448 200h-416c-13.425781 0-24.871094 8.28125-29.625 20 4.753906 11.71875 16.199219 20 29.625 20h416c13.425781 0 24.871094-8.28125 29.625-20-4.753906-11.71875-16.199219-20-29.625-20zm0 0",
  fill: "#cb9e78"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m240 0c-17.671875 0-32 14.328125-32 32v160c0 17.671875 14.328125 32 32 32s32-14.328125 32-32v-160c0-17.671875-14.328125-32-32-32zm0 0",
  fill: "#52575f"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m228 2.375c-11.71875 4.753906-20 16.199219-20 29.625v160c0 13.425781 8.28125 24.871094 20 29.625 11.71875-4.753906 20-16.199219 20-29.625v-160c0-13.425781-8.28125-24.871094-20-29.625zm0 0",
  fill: "#666d77"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m448 240v208c0 17.671875-14.328125 32-32 32h-352c-17.671875 0-32-14.328125-32-32v-208",
  fill: "#bf4653"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m64 480h350.871094c.664062-2.566406 1.128906-5.222656 1.128906-8v-208h-384v184c0 17.671875 14.328125 32 32 32zm0 0",
  fill: "#dc6068"
});

var _ref9 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "m184 432c-13.257812 0-24-10.742188-24-24v-96c0-13.257812 10.742188-24 24-24s24 10.742188 24 24v96c0 13.257812-10.742188 24-24 24zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m104 432c-13.257812 0-24-10.742188-24-24v-96c0-13.257812 10.742188-24 24-24s24 10.742188 24 24v96c0 13.257812-10.742188 24-24 24zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296 432c-13.257812 0-24-10.742188-24-24v-96c0-13.257812 10.742188-24 24-24s24 10.742188 24 24v96c0 13.257812-10.742188 24-24 24zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m376 432c-13.257812 0-24-10.742188-24-24v-96c0-13.257812 10.742188-24 24-24s24 10.742188 24 24v96c0 13.257812-10.742188 24-24 24zm0 0"
}));

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m360 64h96v16h-96zm0 0",
  fill: "#eebc5a"
});

var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "480pt",
    viewBox: "0 0 480 480",
    width: "480pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.1ad93f5d.svg";
export { ForwardRef as ReactComponent };